import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { rootRouterConfig } from "./root.routes";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from "@angular/http";

import { SpondCommonModule } from "../../../common/common.module";

import { RootComponent } from "./root.component";
import { CommonModule } from "@angular/common";

import { HttpClientModule } from "@angular/common/http";
import { SpinnerButtonModule } from "../../../common/components/spinnerButton";
import { SpondAlertModule } from "../../../common/components/alert/spond-alert.module";
import { LoginComponent } from "./login.component";
import { ForgotPasswordComponent } from "../forgot-password/forgot-password.component";
import { VerifyCodeComponent } from "../verify-code/verify-code.component";
import { HomePageProviderModule } from "../../../common/components/home-page-provider/home-page-provider.module";
import { ConfirmModalModule } from "../../../common/components/confirmModal";
import { ModalModule } from "ng2-bootstrap/modal";

@NgModule({
    declarations: [RootComponent, LoginComponent, ForgotPasswordComponent, VerifyCodeComponent],
    imports: [
        BrowserModule,
        CommonModule,
        HomePageProviderModule,
        SpondCommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        HttpClientModule,
        RouterModule.forRoot(rootRouterConfig, { useHash: false }),
        SpinnerButtonModule,
        SpondAlertModule,
        ModalModule.forRoot(),
        ConfirmModalModule,
    ],
    bootstrap: [RootComponent],
})
export class RootModule {}
